// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/business.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/business.proto.
 */
export const file_proto_model_core_place_types_business = /*@__PURE__*/
  fileDesc("Citwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2J1c2luZXNzLnByb3RvEgZjYXJtZW4qnwEKEUJ1c2luZXNzUGxhY2VUeXBlEiMKH0JVU0lORVNTX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIoCiRCVVNJTkVTU19QTEFDRV9UWVBFX0NPUlBPUkFURV9PRkZJQ0UQARIcChhCVVNJTkVTU19QTEFDRV9UWVBFX0ZBUk0QAhIdChlCVVNJTkVTU19QTEFDRV9UWVBFX1JBTkNIEANCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the enum carmen.BusinessPlaceType.
 */
export const BusinessPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_business, 0);

/**
 * Business-related place types
 *
 * @generated from enum carmen.BusinessPlaceType
 */
export const BusinessPlaceType = /*@__PURE__*/
  tsEnum(BusinessPlaceTypeSchema);

